function toggleMobileMenu() {
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.getElementById('mobile-overlay');
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  
  // Toggle Tailwind classes instead of custom CSS classes
  mobileMenu.classList.toggle('translate-x-full');
  mobileMenu.classList.toggle('translate-x-0');
  
  mobileOverlay.classList.toggle('opacity-0');
  mobileOverlay.classList.toggle('opacity-100');
  mobileOverlay.classList.toggle('pointer-events-none');
  mobileOverlay.classList.toggle('pointer-events-auto');
  
  menuToggle.classList.toggle('active');
  
  if (!mobileMenu.classList.contains('translate-x-full')) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}
  
  // Close mobile menu when clicking on a link
  document.addEventListener('DOMContentLoaded', function() {
    const mobileNavLinks = document.querySelectorAll('.nav-menu-mobile a');
    mobileNavLinks.forEach(link => {
      link.addEventListener('click', () => {
        toggleMobileMenu();
      });
    });
  });